<div class="container">
    <a
        class="si-header-item btn btn-circle btn-ghost"
        [routerLink]="['/main', 'search']"
        [siTooltip]="'header-actions-tooltip-search' | translate"
        [attr.aria-label]="'header-actions-label-search' | translate"
    >
        <si-icon icon="element-search" />
    </a>
    <a
        class="si-header-item btn btn-circle btn-ghost"
        [routerLink]="['/settings']"
        [siTooltip]="'header-actions-tooltip-settings' | translate"
        [attr.aria-label]="'header-actions-label-settings' | translate"
    >
        <si-icon icon="element-settings" />
    </a>
    <button
        type="button"
        class="si-header-item btn btn-circle btn-ghost"
        [siHeaderDropdownTriggerFor]="helpDropdown"
        [siTooltip]="'header-actions-tooltip-help' | translate"
        [attr.aria-label]="'header-actions-label-help' | translate"
    >
        <si-icon icon="element-help" />
    </button>
    <a class="scf-icon" [routerLink]="['/main']" [attr.aria-label]="'header-actions-label-basic-templates' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" fill="none" aria-hidden="true">
            <text
                x="100"
                y="60"
                text-anchor="middle"
                font-family="'Siemens Sans','Arial',sans-serif"
                font-weight="700"
                font-size="46"
                letter-spacing="2"
                fill="currentColor"
            >
                SCF
            </text>
            <g stroke="currentColor" stroke-width="5" stroke-linejoin="round" stroke-linecap="round">
                <rect x="58" y="82" width="84" height="108" rx="2" fill="none" />
                <rect x="72" y="98" width="38" height="20" fill="none" />
                <line x1="72" y1="158" x2="128" y2="158" />
                <line x1="72" y1="172" x2="128" y2="172" />
            </g>
        </svg>
    </a>
</div>
<ng-template #helpDropdown>
    <si-header-dropdown>
        <div class="flex w-[400px] flex-col gap-1 p-6 text-text-primary">
            <h3 class="font-siemens m-0 mb-2 text-base font-semibold text-[var(--scf-primary)]">
                {{ 'header-actions-title' | translate }}
            </h3>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    href="https://wiki.siemens.com/spaces/en/pages/559016457/Siemens+Corporate+Forms+SCF"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-scf-wiki' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a [href]="scfQuickStartUrl" target="blank" class="font-siemens text-text-primary hover:underline">
                    {{ 'header-actions-quick-start' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a [href]="scfHelpUrl" target="blank" class="font-siemens text-text-primary hover:underline">
                    {{ 'header-actions-help' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a [href]="myLearningWorldLink" target="_blank" class="font-siemens text-text-primary hover:underline">
                    {{ 'header-actions-my-learning-world' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    [href]="scfTemplatesBucketUrl + '/help/SCF-Add-on.pdf'"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-scf-addon' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    href="mailto:help.scf@siemens.com"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-contact' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    [href]="standardVivaEngageLink"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-yammer' | translate }}
                </a>
            </div>

            <hr class="my-2 border-ui-2" />

            <h3 class="font-siemens m-0 mb-2 text-base font-semibold text-[var(--scf-primary)]">
                {{ 'header-actions-news' | translate }}
            </h3>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    [href]="scfTemplatesBucketUrl + '/help/SCF-News.pdf'"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-scfv10-info' | translate }}
                </a>
            </div>

            <hr class="my-2 border-ui-2" />

            <h3 class="font-siemens m-0 mb-2 text-base font-semibold text-[var(--scf-primary)]">
                {{ 'header-actions-related-links' | translate }}
            </h3>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    [href]="themeLinks?.paperGuidelines || standardPaperGuidlinesLink"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-paper-guidelines' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    href="http://sal.siemens.cloud/home"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-sal' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    href="https://soc.siemens.cloud/"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-soc' | translate }}
                </a>
            </div>
            <div class="flex flex-row items-center gap-2 py-1.5 pl-1">
                <si-icon icon="element-link" class="text-base" />
                <a
                    href="{{ scfTeamIntranetPageUrl }}"
                    target="blank"
                    class="font-siemens text-text-primary hover:underline"
                >
                    {{ 'header-actions-team-homepage' | translate }}
                </a>
            </div>
        </div>
    </si-header-dropdown>
</ng-template>
